import { render, staticRenderFns } from "./chanpin.vue?vue&type=template&id=6905819d&scoped=true"
import script from "./chanpin.vue?vue&type=script&lang=js"
export * from "./chanpin.vue?vue&type=script&lang=js"
import style0 from "./chanpin.vue?vue&type=style&index=0&id=6905819d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6905819d",
  null
  
)

export default component.exports